import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import { createServices, updateServices, getCustomers, getPettyCash, createExpanse, updateExpanse, createCustomers, postGeneralData, getBankBalance, getExpanses } from "../../../Utility/Api";
import { WarehouseContext } from "../../../Utility/UserContext";
import CustomerAddModal from '../../Common/CustomerAddModal';
import { getFormattedCurrentDate2 } from "../../../Utility/function";

const AddExpenseForm = ({ unit, showModal, closeModal, refreshList, type, in_or_out }) => {
    const { showLoader, hideLoader, UserItem, shopItem } = useContext(WarehouseContext);
    const [user, setuser] = useState(UserItem)
    const [expenseData, setExpenseData] = useState({
        title: type == 1 ? "Capital" : "",
        date: "",
        customer_id: "",
        amount: "",
        remark: "",
        status: "",
        mop: "", // Mode of Payment
        paid_by: UserItem?.user_id,
        is_credit: "", // Credit status
        received_by: "",
        type: type || 0, // 0: Petty Cash, 1: Other Expense
        in_or_out: in_or_out, // 1: Expense
        petty_cash_id: "", // Only for Petty Cash
        remaining: "" // Remaining balance for Petty Cash
    });

    const [returnPetty, setReturnPetty] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setSelectedFile(file);
    };
    const [remaining, setRemaining] = useState("0");
    const [customers, setCustomers] = useState([]);
    const [pettyCash, setPettyCash] = useState([]);
    const [pettyCashBalance, setPettyCashBalance] = useState(0);
    const [showCustomer, setShowCustomer] = useState(false);
    const [previousBalance, setPreviousBalance] = useState(false);
    const [pettyCashDate, setPettyCashDate] = useState("");
    const [bankBalance, setBankBalance] = useState(null);
    const [amountError, setAmountError] = useState("");

    const [expenseTypes, setExpenseTypes] = useState([]);
    const [expenseTypeSearch, setExpenseTypeSearch] = useState("");
    const [showDropdown, setShowDropdown] = useState(false);

    // Initialize expense types dynamically by fetching recorded expenses and combining with local storage
    useEffect(() => {
        const fetchExistingExpenseTypes = async () => {
            let storedTypes = [];
            const stored = localStorage.getItem("ztr_expense_types");
            if (stored) {
                try {
                    const defaultTypes = ["Shop Stationery", "Product Processing Charges", "Rent", "Salary", "Electricity", "Internet/Telephone", "Office Supplies", "Travel & Fuel", "Other"];
                    storedTypes = JSON.parse(stored).filter(t => t && !defaultTypes.includes(t));
                } catch (e) {
                    storedTypes = [];
                }
            }

            try {
                // Fetch recorded expenses for this shop
                const response = await getExpanses(`shop_id=${shopItem?.id || shopItem?.shop_id || ""}`);
                if (response?.data?.data) {
                    const uniqueRecorded = [];
                    const seen = new Set();

                    response.data.data.forEach(item => {
                        const title = item.title ? item.title.trim() : "";
                        if (title && title !== "Capital" && !seen.has(title.toLowerCase())) {
                            seen.add(title.toLowerCase());
                            uniqueRecorded.push(title);
                        }
                    });

                    storedTypes.forEach(t => {
                        const title = t.trim();
                        if (title && !seen.has(title.toLowerCase())) {
                            seen.add(title.toLowerCase());
                            uniqueRecorded.push(title);
                        }
                    });

                    // Sort alphabetically
                    const sorted = uniqueRecorded.sort((a, b) => a.localeCompare(b));
                    setExpenseTypes(sorted);
                    localStorage.setItem("ztr_expense_types", JSON.stringify(sorted));
                } else {
                    const sortedStored = [...new Set(storedTypes)].sort((a, b) => a.localeCompare(b));
                    setExpenseTypes(sortedStored);
                }
            } catch (error) {
                console.error("Error fetching dynamic expense types:", error);
                const sortedStored = [...new Set(storedTypes)].sort((a, b) => a.localeCompare(b));
                setExpenseTypes(sortedStored);
            }
        };

        if (shopItem) {
            fetchExistingExpenseTypes();
        }
    }, [shopItem]);


    useEffect(() => {
        console.log(type)
        fetchCustomers();
        fetchPettyCah();
        fetchBankBalance();
    }, []);

    useEffect(() => {
        if (!expenseData.date) {
            setExpenseData(prev => ({
                ...prev,
                date: new Date().toISOString().split("T")[0]
            }));
        }
    }, []);


    useEffect(() => {
        if (unit) {
            setExpenseData({
                title: unit.title || '',
                date: unit.date || '',
                customer_id: unit.customer_id || '',
                amount: unit.amount || '',
                remark: unit.remark || '',
                status: unit.status || '',
                mop: unit.mop || '',
                paid_by: unit.paid_by || '',
                is_credit: unit.is_credit || '',
                received_by: unit.received_by || '',
                type: unit.type || '',
                in_or_out: unit.in_or_out || '',
                petty_cash_id: unit.petty_cash_id || '',
                remaining: unit.remaining || '',
            });
            setPreviousBalance(parseFloat(unit.amount || '0'));
            setExpenseTypeSearch(unit.title || '');
        }
    }, [unit]);

    const fetchCustomers = async () => {
        try {
            const response = await getCustomers();
            if (response.data && response.data.data) {
                setCustomers(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching suppliers data:", error);
        }
    };

    const fetchPettyCah = async () => {
        try {
            const response = await getPettyCash();
            if (response.data && response.data.data) {
                setPettyCash(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching suppliers data:", error);
        }
    };

    const fetchBankBalance = async () => {
        try {
            const response = await getBankBalance(shopItem?.id);
            if (response?.data?.bank_balance !== undefined) {
                setBankBalance(response.data.bank_balance);
            }
        } catch (error) {
            console.error("Error fetching bank balance:", error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setExpenseData({ ...expenseData, [name]: value });

        if (name === "title") {
            setExpenseTypeSearch(value);
        }

        // Real-time bank balance validation for expense outflows
        if (name === "amount" && in_or_out === "1" && type != 1) {
            const entered = parseFloat(value) || 0;
            if (bankBalance !== null && entered > bankBalance) {
                setAmountError(`Exceeds bank balance! Available: ₹${bankBalance.toLocaleString()}`);
            } else {
                setAmountError("");
            }
        }

        if (name == "petty_cash_id") {
            var pdata = pettyCash.find((data) => data.id == value);
            console.log("petty_cash_id", value);
            console.log("pdata", pdata);
            if (pdata?.remaining) {
                setRemaining(pdata.remaining)
                setPettyCashDate(pdata.date);
            }
        }

        if (name === "date" && pettyCashDate && value < pettyCashDate) {
            toast.error(`You must select a date on or after ${pettyCashDate}`);
            setExpenseData(prev => ({ ...prev, date: pettyCashDate }));
            return;
        }
    };

    const handleSelectExpenseType = (selectedType) => {
        setExpenseTypeSearch(selectedType);
        setExpenseData(prev => ({ ...prev, title: selectedType }));
        setShowDropdown(false);
    };

    const handleExpenseTypeSearchChange = (e) => {
        const val = e.target.value;
        setExpenseTypeSearch(val);
        setExpenseData(prev => ({ ...prev, title: val }));
        setShowDropdown(true);
    };

    const handleAddExpenseType = () => {
        const name = expenseTypeSearch.trim();
        if (!name) {
            toast.error("Please type the new expense type in the search box first");
            return;
        }
        if (expenseTypes.some(t => t.toLowerCase() === name.toLowerCase())) {
            toast.error("Expense type already exists");
            return;
        }
        const updatedList = [...expenseTypes, name];
        setExpenseTypes(updatedList);
        localStorage.setItem("ztr_expense_types", JSON.stringify(updatedList));
        setExpenseTypeSearch(name);
        setExpenseData(prev => ({ ...prev, title: name }));
        toast.success(`Expense type "${name}" added successfully`);
    };

    useEffect(() => {
        if (expenseData.type === "0" && expenseData.petty_cash_id) {
            fetchPettyCashBalance(expenseData.petty_cash_id);
        }
    }, [expenseData.petty_cash_id]);

    const fetchPettyCashBalance = async (pettyCashId) => {
        try {
            // const balance = await getPettyCashBalance(pettyCashId);
            // setPettyCashBalance(balance);
        } catch (error) {
            toast.error("Failed to fetch petty cash balance");
        }
    };

    const postExpenseLedger = async (responseId) => {
        const isPetty = !!expenseData.petty_cash_id;

        // Debit General Expenses (type "6")
        await postGeneralData({
            // old code before issue: 
            // type: isPetty ? "6.1" : "6",

            type: "6",
            ref_id: responseId,
            remarks: "Expense - " + (expenseData?.title || "Expense Entry"),
            date: expenseData.date || getFormattedCurrentDate2(),
            created_by: user?.user_id,
            shop_id: shopItem?.id || "0",
            amount: expenseData?.amount,
            // old code before issue: 
            // is_debit: isPetty ? "0" : "1",

            is_debit: "1", // Debit
        });

        // new code after issue fix If paid from Petty Cash, also Credit Bank/Cash (type "2") to reduce total asset cash pool
        // if (isPetty) {
        await postGeneralData({
            type: "2",
            ref_id: responseId,
            remarks: "Bank Entry - " + (expenseData?.title || "Expense Entry"),
            date: expenseData.date || getFormattedCurrentDate2(),
            created_by: user?.user_id,
            shop_id: shopItem?.id || "0",
            amount: expenseData?.amount,
            is_debit: "0", // Credit
            name: "Bank",
        });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        showLoader();
        try {
            let updatedData = {
                ...expenseData,
                shop_id: shopItem?.shop_id
            };

            // Enforce Expense Type is mandatory
            if (type != 1 && (!expenseData.title || !expenseData.title.trim())) {
                toast.error("Expense Type is mandatory.");
                hideLoader();
                return;
            }

            // Prevent save if date invalid
            if (expenseData.petty_cash_id && expenseData.date < pettyCashDate) {
                toast.error(`Cannot submit. Date must be after petty cash started: ${pettyCashDate}`);
                hideLoader();
                return;
            }

            // Bank balance guard for outgoing expenses
            if (in_or_out === "1" && type != 1 && bankBalance !== null) {
                const entered = parseFloat(expenseData.amount) || 0;
                if (entered > bankBalance) {
                    toast.error(`Insufficient bank balance! Available: ₹${bankBalance.toLocaleString()}, Required: ₹${entered.toLocaleString()}`);
                    hideLoader();
                    return;
                }
            }


            if (expenseData.type === "0" && expenseData.in_or_out === "1") {
                const remainingBalance = parseFloat(remaining) - parseFloat(expenseData.amount);
                if (remainingBalance < 0) {
                    toast.error("Not enough petty cash available");
                    hideLoader();
                    return;
                }
                updatedData.remaining = remainingBalance;
            }

            const payload = new FormData();
            Object.keys(updatedData).forEach(key => {
                if (key !== 'file' && updatedData[key] !== null && updatedData[key] !== undefined) {
                    payload.append(key, updatedData[key]);
                }
            });
            if (selectedFile) {
                payload.append("file", selectedFile);
            }

            if (unit) {
                await updateExpanse(unit.id, payload);
                toast.success("Expense updated successfully");
                // if (expenseData.type == 1 && expenseData.in_or_out == "0") {
                if ((expenseData.type == 1 || expenseData.type == 0) && expenseData.in_or_out == "0") {
                    var amt = parseFloat(expenseData.amount || 0) - previousBalance;
                    const generalDataPayload = {
                        type: "1",
                        ref_id: unit?.id || "",
                        // remarks: "Capital",
                        remarks: expenseData.type == 1 ? "Capital" : "Capital - Petty Cash Deposit",
                        date: expenseData.date || getFormattedCurrentDate2(),
                        created_by: user?.user_id,
                        shop_id: shopItem?.id || "0",
                        amount: amt,
                        is_debit: "0",
                    };
                    await postGeneralData(generalDataPayload);

                    const bankEntryPayload = {
                        type: "2",
                        ref_id: unit?.id || "",
                        // remarks: "Bank Entry - Capital",
                        remarks: "Bank Entry - " + (expenseData.type == 1 ? "Capital" : "Capital - Petty Cash Deposit"),
                        date: expenseData.date || getFormattedCurrentDate2(),
                        created_by: user?.user_id,
                        shop_id: shopItem?.id || "0",
                        amount: amt,
                        is_debit: "1",
                        name: "Bank",
                    };
                    await postGeneralData(bankEntryPayload);
                }
            } else {
                const response = await createExpanse(payload);
                if (response) {
                    const createdId = response?.data?.data?.id || response?.data?.id || response?.id || "";
                    try {
                        // if (type == 1 && expenseData.in_or_out == "0") {
                        if ((type == 1 || type == 0) && expenseData.in_or_out == "0") {
                            const generalDataPayload = {
                                // type: type == 1 ? "1" : "6",
                                type: "1",
                                ref_id: createdId,
                                // remarks: type == 1 ? "Capital" : "Expense - " + expenseData?.title || "Expense Entry",
                                remarks: type == 1 ? "Capital" : "Capital - Petty Cash Deposit",
                                date: expenseData.date || getFormattedCurrentDate2(),
                                created_by: user?.user_id,
                                shop_id: shopItem?.id || "0",
                                amount: expenseData?.amount,
                                // is_debit: type == 1 ? "0" : expenseData.in_or_out == "0" ? "1" : "0",
                                is_debit: "0",
                            };
                            await postGeneralData(generalDataPayload);

                            const bankEntryPayload = {
                                type: "2",
                                ref_id: createdId,
                                remarks: "Bank Entry - " + (expenseData?.title || "Expense Entry"),
                                date: expenseData.date || getFormattedCurrentDate2(),
                                created_by: user?.user_id,
                                shop_id: shopItem?.id || "0",
                                amount: expenseData?.amount,
                                // is_debit: type == 1 ? "1" : "0",
                                is_debit: "1",
                                name: "Bank",
                            };
                            await postGeneralData(bankEntryPayload);
                            // else if (type != 1 && expenseData.in_or_out == "0") {
                        } else if (type == 2 && expenseData.in_or_out == "0") {
                            const generalDataPayload = {
                                // type: type == 1 ? "1" : "6",
                                type: "6",
                                ref_id: createdId,
                                // remarks: type == 1 ? "Capital" : "Expense - " + expenseData?.title || "Expense Entry",
                                remarks: "Expense - " + (expenseData?.title || "Expense Entry"),
                                date: expenseData.date || getFormattedCurrentDate2(),
                                created_by: user?.user_id,
                                shop_id: shopItem?.id || "0",
                                amount: expenseData?.amount,
                                // is_debit: type == 1 ? "0" : expenseData.in_or_out == "0" ? "1" : "0",
                                is_debit: "1",
                            };
                            await postGeneralData(generalDataPayload);

                            const bankEntryPayload = {
                                type: "2",
                                ref_id: createdId,
                                remarks: "Bank Entry - " + (expenseData?.title || "Expense Entry"),
                                date: expenseData.date || getFormattedCurrentDate2(),
                                created_by: user?.user_id,
                                shop_id: shopItem?.id || "0",
                                amount: expenseData?.amount,
                                is_debit: "0",
                                name: "Bank",
                            };
                            await postGeneralData(bankEntryPayload);
                        } else if (type != 1 && expenseData.in_or_out == "1") {
                            await postExpenseLedger(createdId);
                        }

                        if (returnPetty) {
                            const pettyCashAddToBank = {
                                type: "2",
                                ref_id: createdId,
                                remarks: "Amount return from " + expenseData.title,
                                date: expenseData.date || getFormattedCurrentDate2(),
                                created_by: user?.user_id,
                                shop_id: shopItem?.id || "0",
                                amount: expenseData?.amount,
                                is_debit: "1",
                            };
                            await postGeneralData(pettyCashAddToBank);
                            const pettyCashRemoveFromExpense = {
                                type: "6",
                                ref_id: createdId,
                                remarks: "Amount return from " + expenseData.title,
                                date: expenseData.date || getFormattedCurrentDate2(),
                                created_by: user?.user_id,
                                shop_id: shopItem?.id || "0",
                                amount: expenseData?.amount,
                                is_debit: "0",
                            };
                            await postGeneralData(pettyCashRemoveFromExpense);
                        }

                    } catch (e) {
                        console.error("General log failed:", e);
                        toast.error("Failed to create general transaction log");
                    }
                    toast.success("Expense added successfully");
                } else {
                    toast.error("Failed to add expense");
                }
            }
            closeModal();
            refreshList();
        } catch (error) {
            const err = error?.response?.data;
            if (err?.message) {
                toast.error(`${err.message} (Required: ${err.required}, Available: ${err.available_bank_balance})`);
            } else {
                toast.error("Error saving expense");
            }
        } finally {
            hideLoader();
        }
    };

    const [Customer, setCustomer] = useState([]);
    const [formdata, setFormdata] = useState({
        name: "",
        contact_email: "",
        phone: "",
        country: "",
        branch: "",
        status: "1",
        additional_details: "",
        TRN_no: '',
        opening_balance: '',
        CR_DR: '',
        shop_id: shopItem?.shop_id || "0",
    });

    const handleChangeCustomer = (e) => {
        const { name, value } = e.target;
        setFormdata({
            ...formdata,
            [name]: value,
        });
    }

    const handleClearCustomer = () => {
        setFormdata({
            name: "",
            contact_email: "",
            phone: "",
            country: "",
            branch: "",
            status: "1",
            additional_details: "",
            TRN_no: '',
            opening_balance: '',
            CR_DR: '',
            shop_id: shopItem?.shop_id || "0",
        });
        setShowCustomer(false)
    }

    const handleAddCustomer = async () => {
        showLoader()
        const validationErrors = {};

        for (const key in formdata) {
            if (key === 'additional_details' || key === 'status') {
                continue;
            }
            if (!formdata[key]) {
                validationErrors[key] = `${key.replace(/_/g, " ")} is required.`;
            }
        }

        if (Object.keys(validationErrors).length > 0) {
            hideLoader()
            toast.error(validationErrors[Object.keys(validationErrors)[0]])
            console.log(validationErrors);
            return;
        }

        console.log("Payload being sent:", formdata);

        try {
            await createCustomers(formdata);
            hideLoader()
            toast.success("Customers Added successfully");
            handleClearCustomer()
            setShowCustomer(false)
            fetchSuppliers();
        } catch (error) {
            console.error("Error  data:", error.response?.data.message);
            hideLoader()
            handleClearCustomer();
            toast.error(error.response?.data.message)
        }
    };

    const fetchSuppliers = async () => {
        try {
            const response = await getCustomers();
            if (response.data && response.data.data) {
                setCustomer(response.data.data);
                // setCustomerId(response.data.data[0].customer_id)
            }
        } catch (error) {
            console.error("Error Fetching Customer data:", error);
        }
    };

    return (
        <div className={`modal fade ${showModal ? "show d-block" : ""}`} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header d-flex flex-column align-items-start gap-1">
                        <div className="d-flex w-100 justify-content-between align-items-center">
                            <h5 className="modal-title">
                                {unit?.id ? 'Update' : 'Record'} {expenseData.type == '0' ? "PattyCash" : expenseData.type == "1" ? "Capital" : expenseData.type == "2" ? "Expenses" : ""}
                            </h5>
                            <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
                        </div>
                        {/* Bank Balance Badge */}
                        {bankBalance !== null && (
                            <div
                                style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    background: bankBalance <= 0 ? "#fee2e2" : "#d1fae5",
                                    border: `1px solid ${bankBalance <= 0 ? "#fca5a5" : "#6ee7b7"}`,
                                    borderRadius: "8px",
                                    padding: "6px 14px",
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    color: bankBalance <= 0 ? "#dc2626" : "#065f46",
                                }}
                            >
                                <span style={{ fontSize: "16px" }}>🏦</span>
                                Bank/Cash Balance:&nbsp;
                                <span style={{ fontSize: "15px", fontWeight: 700 }}>
                                    ₹{bankBalance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </span>
                                {bankBalance <= 0 && (
                                    <span style={{ color: "#dc2626", fontWeight: 700 }}>⚠ No funds available</span>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                {/* Left Side */}
                                {type != 1 ? (
                                    <div className="col-6">
                                        <div className="form-group mb-3 position-relative">
                                            <label>Expense Type:</label>
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search/Select Expense Type..."
                                                    value={expenseTypeSearch}
                                                    onChange={handleExpenseTypeSearchChange}
                                                    onFocus={() => setShowDropdown(true)}
                                                    onBlur={() => setTimeout(() => setShowDropdown(false), 250)}
                                                    required
                                                    style={{
                                                        borderTopRightRadius: 0,
                                                        borderBottomRightRadius: 0,
                                                        borderRight: "none"
                                                    }}
                                                />
                                                <button
                                                    className="btn btn-outline-primary"
                                                    type="button"
                                                    onClick={handleAddExpenseType}
                                                    style={{
                                                        borderTopLeftRadius: 0,
                                                        borderBottomLeftRadius: 0
                                                    }}
                                                >
                                                    + Add
                                                </button>
                                            </div>
                                            {showDropdown && (
                                                <ul
                                                    className="dropdown-menu show w-100"
                                                    style={{
                                                        maxHeight: "200px",
                                                        overflowY: "auto",
                                                        position: "absolute",
                                                        zIndex: 1050,
                                                        boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)"
                                                    }}
                                                >
                                                    {expenseTypes.filter(t => t.toLowerCase().includes(expenseTypeSearch.toLowerCase())).length > 0 ? (
                                                        expenseTypes
                                                            .filter(t => t.toLowerCase().includes(expenseTypeSearch.toLowerCase()))
                                                            .map((t, idx) => (
                                                                <li key={idx}>
                                                                    <button
                                                                        className="dropdown-item"
                                                                        type="button"
                                                                        onMouseDown={() => handleSelectExpenseType(t)}
                                                                    >
                                                                        {t}
                                                                    </button>
                                                                </li>
                                                            ))
                                                    ) : (
                                                        <li>
                                                            <span className="dropdown-item text-muted">No matching expense types</span>
                                                        </li>
                                                    )}
                                                </ul>
                                            )}
                                        </div>

                                        <div className="form-group mb-3">
                                            <label>Title:</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="title"
                                                value={expenseData.title}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>

                                        <div className="form-group mb-3">
                                            <label>Date:</label>
                                            <input
                                                type="date"
                                                max={new Date().toISOString().split("T")[0]}
                                                className="form-control"
                                                name="date"
                                                value={expenseData.date}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>

                                        <div className="form-group mb-3">
                                            <label>Attach File/Image:</label>
                                            <input
                                                type="file"
                                                className="form-control"
                                                onChange={handleFileChange}
                                                accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                                            />
                                            {expenseData.file && typeof expenseData.file === "string" && (
                                                <div className="mt-2">
                                                    <a
                                                        href={(() => {
                                                            if (expenseData.file.startsWith("http")) return expenseData.file;
                                                            const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
                                                            const baseUrl = isLocal ? "http://127.0.0.1:8000" : "http://193.203.162.101:8002";
                                                            const cleanPath = expenseData.file.startsWith("/") ? expenseData.file.substring(1) : expenseData.file;
                                                            if (cleanPath.startsWith("media/")) {
                                                                return `${baseUrl}/${cleanPath}`;
                                                            }
                                                            return `${baseUrl}/media/${cleanPath}`;
                                                        })()}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="btn btn-outline-info btn-xs py-1 px-2 text-xs"
                                                        style={{ textDecoration: "none" }}
                                                    >
                                                        View Current Attachment
                                                    </a>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="col-12">
                                        <div className="form-group mb-3">
                                            <label>Date:</label>
                                            <input
                                                type="date"
                                                min={expenseData.petty_cash_id ? pettyCashDate : ""}
                                                max={new Date().toISOString().split("T")[0]}
                                                className="form-control"
                                                name="date"
                                                value={expenseData.date}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                )}

                                {/* Right Side */}
                                <div className={type != 1 ? "col-6" : "col-12"}>
                                    <div className="form-group mb-3">
                                        <label>
                                            Amount (INR):{" "}
                                            {expenseData.type === "0" && expenseData.in_or_out === "1" && (
                                                <>
                                                    Remaining :{" "}
                                                    <span className="text-danger fw-bold">{remaining}</span>
                                                </>
                                            )}
                                        </label>
                                        <input
                                            type="number"
                                            className={`form-control ${amountError ? "is-invalid" : ""}`}
                                            name="amount"
                                            value={expenseData.amount}
                                            onChange={handleInputChange}
                                            min="0"
                                            max={in_or_out === "1" && type != 1 && bankBalance !== null ? bankBalance : undefined}
                                            required
                                        />
                                        {amountError && (
                                            <div className="invalid-feedback" style={{ fontWeight: 600 }}>
                                                {amountError}
                                            </div>
                                        )}
                                    </div>

                                    {expenseData.type == "0" && expenseData.in_or_out == "1" && (
                                        <>
                                            <div className="form-group mb-3">
                                                <label>Petty Cash:</label>
                                                <select
                                                    className="form-control"
                                                    name="petty_cash_id"
                                                    value={expenseData.petty_cash_id}
                                                    onChange={handleInputChange}
                                                    required
                                                >
                                                    <option value="">Select Petty Cash</option>
                                                    {pettyCash.map((customer) => (
                                                        <option key={customer.id} value={customer.id}>
                                                            {customer.title}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* <div className="form-group mb-3 form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    checked={returnPetty}
                                                    onChange={(e) => setReturnPetty(e.target.checked)}
                                                />
                                                <label className="form-check-label">
                                                    Return unused amount to bank after this expense
                                                </label>
                                            </div> */}
                                        </>
                                    )}

                                    <div className="form-group mb-3">
                                        <label>Remark:</label>
                                        <textarea
                                            className="form-control"
                                            style={{ minHeight: "5px" }}
                                            name="remark"
                                            value={expenseData.remark}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                            </div>


                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={closeModal}>Close</button>
                                <button type="submit" className="btn btn-success">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <CustomerAddModal
                showCustomer={showCustomer}
                setShowCustomer={setShowCustomer}
                onReqCustomer={fetchSuppliers} />
        </div>
    );
};

export default AddExpenseForm;
